export default __webpack_public_path__ + "static/media/P350_RoHS.b27a75d5.pdf";